export function LogoIcon({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="HighRank.space logo">
      <rect x="2" y="2" width="60" height="60" rx="16" fill="#3FE08C" />
      <path
        d="M17 45 L28 34 L34 40 L49 23"
        stroke="#0B0B0B"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M39 22 L50 22 L50 33"
        stroke="#0B0B0B"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default function Logo({ small = false }) {
  return (
    <span className="flex items-center gap-2 group">
      <span
        className={`${small ? "w-7 h-7" : "w-8 h-8"} inline-flex transition-transform duration-300 group-hover:rotate-6`}
      >
        <LogoIcon className="w-full h-full" />
      </span>
      <span className={`font-display ${small ? "text-xl" : "text-2xl"} tracking-[0.08em] pt-0.5`}>
        <span>HIGHRANK</span>
        <span className="font-script text-[#3FE08C] text-[1.3em] leading-none">.space</span>
      </span>
    </span>
  );
}
